import { render } from "./Bpmn.vue?vue&type=template&id=159d08c3&scoped=true"
import script from "./Bpmn.vue?vue&type=script&lang=js"
export * from "./Bpmn.vue?vue&type=script&lang=js"

import "./Bpmn.vue?vue&type=style&index=0&id=159d08c3&scoped=true&lang=css"
import "./Bpmn.vue?vue&type=style&index=1&id=159d08c3&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-159d08c3"]])

export default __exports__